import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
		label: {
			fontWeight: "bold"
		},
		noteLabel: {
			fontWeight: "bold"
		},
		labelSpace: {
			marginTop:'8px'
		},
		stackedGroup: {
			marginTop: 4,
			alignItems: "flex-start",
			"& .MuiFormControlLabel-root": {
				marginLeft: 0,
			},
		},
	} satisfies Record<string, CSSObject>);
};
